import { render, staticRenderFns } from "./Customer-Search.vue?vue&type=template&id=0a4b57d2&"
import script from "./Customer-Search.vue?vue&type=script&lang=js&"
export * from "./Customer-Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports